import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import { color } from 'src/color/color'

export const useStyles = makeStyles((theme: Theme) => createStyles({
  icon: {
    width: '2.4rem',
    margin: theme.spacing(0, 1, 0, 0),
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    color: color('white'),
    '&:active': {
      color: `${color('white')} !important`,
    },
    '&:focus': {
      color: `${color('white')} !important`,
    },
    '&:hover': {
      color: `${color('white')} !important`,
    },
  },
  linkText: {
    fontWeight: 400,
  },
  text: {
    margin: theme.spacing(0, 0, 2.5),
    fontWeight: 400,
    color: color('white'),
    letterSpacing: '0.7px',
  },
}))
